<script lang="ts">
  import CountdownBase from './CountdownBase.svelte';
  import { convertMsToTime } from '$lib/utils/time';
  import { browser } from '$app/environment';

  export let time: number;

  $: timeLeft = convertMsToTime(Math.max(time, 0), { hours: true, seconds: true, minutes: true });
</script>

{#if browser}
  <CountdownBase bind:time />
{/if}
<span>{timeLeft}</span>
